module.exports = __webpack_public_path__ + "static/media/image_3_1.13e4e6cc.png";